import React from "react";
import { InactiveTenant } from "../../../types/email-tracking.types";

interface InactiveTenantsProps {
  data: InactiveTenant[];
}

/**
 * Polish pluralization for "mail/maile/maili".
 * Rules:
 * - 1 -> "mail"
 * - 2-4, 22-24, 32-34, ... -> "maile"
 * - 0, 5-21, 25-31, ... and 12-14 -> "maili"
 */
function pluralMail(n: number): string {
  if (n === 1) return "mail";
  const lastTwo = n % 100;
  const last = n % 10;
  if (lastTwo >= 12 && lastTwo <= 14) return "maili";
  if (last >= 2 && last <= 4) return "maile";
  return "maili";
}

export const InactiveTenants: React.FC<InactiveTenantsProps> = ({ data }) => {
  if (!data.length) {
    return (
      <div className="bg-white rounded-lg border border-neutral-200 p-4">
        <h4 className="text-sm font-semibold text-neutral-900 mb-3">
          Tenanci bez otwarć
        </h4>
        <p className="text-xs text-neutral-500 mb-3">
          Aktywni tenanci (moduł alertów), którzy dostali maile ale żadnego nie
          otworzyli.
        </p>
        <div className="text-neutral-500 text-sm">Brak nieaktywnych tenantów w wybranym okresie.</div>
      </div>
    );
  }

  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-4"
      data-testid="ranking-inactive-tenants"
      role="region"
      aria-label="Tenanci bez otwarć"
    >
      <h4 className="text-sm font-semibold text-neutral-900 mb-1">
        Tenanci bez otwarć
      </h4>
      <p className="text-xs text-neutral-500 mb-3">
        Aktywni tenanci (moduł alertów), którzy dostali maile ale żadnego nie otworzyli.
      </p>

      <div className="space-y-2">
        {data.map((t, index) => (
          <div
            key={t.tenantId}
            className="flex items-center justify-between py-2 border-b border-neutral-50 last:border-0"
            data-testid={`inactive-tenant-row-${index}`}
          >
            <div className="flex-1 min-w-0 truncate" title={t.tenantName}>
              <span className="text-sm text-neutral-900">{t.tenantName}</span>
            </div>
            <div className="text-sm text-neutral-700 whitespace-nowrap ml-3">
              {t.sent} {pluralMail(t.sent)} bez otwarcia
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InactiveTenants;
